module.exports = __webpack_public_path__ + "img/engine-piston.a5601375.jpg";